import PropTypes from 'prop-types';
import React from 'react';

import { localTime } from 'utils/LocalDateTimeHelper';
import { filterRunsByStatus } from 'modules/GreyhoundRacing/utils/runFilter';

import GreyhoundRacingRaceDetails from './GreyhoundRacingRaceDetails';
import GreyhoundRacingRacecardResultRunner from "./GreyhoundRacingRacecardResultRunner";
import GreyhoundRacingRacecardResultNonRunners from "./GreyhoundRacingRacecardResultNonRunners";

function hideNull(element) {
  return element ? element : '';
}

function bracket(element) {
  return element ? `(${element})` : '';
}

function transformData(runners) {
  const hn = hideNull;
  return (runners.map(runner => ({
    key : runner.run_reference.id,
    clothNo: hn(runner.cloth_number),
    position : hn(runner.finish_position),
    finishDistance : hn(runner.finish_distance),
    form : hn(runner.greyhound.formsummary.display_text),
    greyhoundName : hn(runner.greyhound.name),
    greyhoundId : hn(runner.greyhound.greyhound_reference.id),
    runDesc : hn(runner.run_description),
    runTime : hn(runner.run_time),
    runSplit : hn(parseFloat(runner.sectional_time)),
    trainer : runner.trainer,
    odds : hn(runner.betting.current_odds) + hn(runner.betting.favourite.betting_favourite),
    reserve: runner.reserve
  })))
}

export default function GreyhoundRacingRacecardPostRace(props){
  const {
    race,
    race: {
      runs : raceRuns,
      race_summary: {
        date: raceDate
      }
    },
    winningTime,
    offTime
  } = props;

  const runners = transformData(filterRunsByStatus(raceRuns, "RUNNER"));
  const nonRunners = transformData(filterRunsByStatus(raceRuns, "NONRUNNER"));

  return (
    <section>
      <div className="gh-racecard-weighed-in-wrapper">
        <h3 className="gh-racecard-weighed-in-title">Final Result</h3>
        <div className="gh-racecard-weighed-in-info">
          <span className="gh-racecard-weighed-in-wt">
            Winning time:<span>{winningTime ? winningTime : '-'}</span>
          </span>
          <span className="gh-racecard-weighed-in-ot">
            Off time:<span>{offTime ? localTime(`${raceDate}T${offTime}Z`) : '-'}</span>
          </span>
        </div>
      </div>
      {
        runners.map((runner) => {
          return <GreyhoundRacingRacecardResultRunner runner={runner} key={runner.key}/>
        })
      }
      <GreyhoundRacingRacecardResultNonRunners nonRunners={nonRunners}/>
      <GreyhoundRacingRaceDetails {...{race}} />
    </section>
  );
}

GreyhoundRacingRacecardPostRace.propTypes = {
  race : PropTypes.object.isRequired,
  meeting: PropTypes.object,
  winningTime: PropTypes.string,
  offTime: PropTypes.string,
  meetings: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardPostRace.js